module.exports = __webpack_public_path__ + "img/arrow-left-search.1a822cea.svg";